import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-steps-page',
  templateUrl: './steps-page.component.html',
  styleUrls: ['./steps-page.component.scss']
})
export class StepsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
